import getJson from "helpers/api/getJson";
import createPromise from "helpers/createPromise";
import getStaticFileUrl from "helpers/getStaticFileUrl";
import { coreLogger } from "helpers/logger";
import { ITCFGatpVendorList as IGoogleVendorListResponse } from "types/tcf";

let cachedGV: IGoogleVendorListResponse;

const fetchGoogleVendorList = (
  version: string | null
): Promise<IGoogleVendorListResponse> => {
  const url = getStaticFileUrl('google/consent-providers.json', version);
  return createPromise<IGoogleVendorListResponse>((resolve, reject) => {
    if (cachedGV) {
      coreLogger('Load cached google vendors list');
      return resolve(cachedGV);
    }

    getJson(url)
      .then(
        ([res]) => {
          coreLogger("Google Vendor List loaded");

          cachedGV = res as IGoogleVendorListResponse;
          resolve(cachedGV);
        },
        e => {
          coreLogger(new Error("Failed to load Google Vendor List"));
          reject(e);
        }
      );
  });
};

export default fetchGoogleVendorList;
